@let props = itemProps();
@for (question of questionsSorted; track question) {
  <bgo-form-summary-item
    [label]="question.label"
    [icon]="props.icon"
    [border]="!$first && props.border"
    [size]="props.size"
  >
    @for (answer of question.answers; track answer) {
      <div>
        {{ answer }}
      </div>
    }
    @if (question.additionalInformation) {
      <div class="mt-xs text-xs">
        {{ question.additionalInformation }}
      </div>
    }
  </bgo-form-summary-item>
}
